import { useEffect } from "react";

import { isMobile } from "react-device-detect";
import { useSpring } from "@react-spring/three";

export const useDeviceRotation = (callback: (beta: number, gamma: number) => void, rotationRange = 45) => {
  useEffect(() => {
    if (isMobile) {
      window.addEventListener("deviceorientation", rotationHandler);
    } else {
      window.addEventListener("mousemove", mouseMoveHandler);
    }

    return () => {
      if (isMobile) {
        window.removeEventListener("deviceorientation", rotationHandler);
      } else {
        window.removeEventListener("mousemove", mouseMoveHandler);
      }
    };
  }, []);

  const [, api] = useSpring(
    () => ({
      x: 0,
      y: 0,
      config: isMobile
        ? {
            tension: 180,
            friction: 10,
            mass: 0.01,
          }
        : {
            tension: 180,
            friction: 60,
            mass: 5,
          },
      onChange: ({ value }) => {
        callback(value.y, value.x);
      },
    }),
    [],
  );

  const rotationHandler = (event: DeviceOrientationEvent) => {
    api.start({ x: event.gamma, y: event.beta });
  };

  const mouseMoveHandler = (event: MouseEvent) => {
    const x = ((event.clientX / window.innerWidth) * 2 - 1) * rotationRange;
    const y = ((event.clientY / window.innerHeight) * 2 - 1) * rotationRange;
    api.start({ x: x, y: y });
  };

  return null;
};
